import { useQuery } from "@tanstack/react-query";

export type CompanySearchResult = {
  id: string;
  orgCompanyId?: string | null;
  name: string;
  website: string;
  industry: string;
  logoId?: string;
  isOrgCompany: boolean;
};

const searchCompanies = async (
  organizationID: string,
  q: string,
): Promise<CompanySearchResult[]> => {
  const token = localStorage.getItem("profiletool-auth-token");
  const baseUrl =
    process.env.REACT_APP_BASE_URL ?? "https://profiletool-api.onrender.com";

  const response = await fetch(
    `${baseUrl}/v1/organizations/${organizationID}/companies/search?q=${encodeURIComponent(q)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) throw new Error("Failed to search companies");
  return response.json();
};

export const useSearchCompanies = (organizationID: string, q: string) =>
  useQuery({
    queryKey: ["companies-search", organizationID, q],
    queryFn: () => searchCompanies(organizationID, q),
    enabled: q.trim().length > 0,
    staleTime: 1000 * 30,
  });
